import { render } from "./CreateProcess.vue?vue&type=template&id=00bc5e32&scoped=true"
import script from "./CreateProcess.vue?vue&type=script&lang=js"
export * from "./CreateProcess.vue?vue&type=script&lang=js"

import "./CreateProcess.vue?vue&type=style&index=0&id=00bc5e32&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00bc5e32"]])

export default __exports__